import { Component, Input, ViewEncapsulation } from "@angular/core";
import { ClassificationStatus } from "../models/classification-indicators.model";


@Component({
    selector: 'app-classification-indicator-status',
    templateUrl: './classification-indicator-status.component.html',
    // styleUrls: ['./classification-indicator-status.component.scss']
    encapsulation: ViewEncapsulation.None
})
export class ClassificationStatusComponent {
    @Input() status: ClassificationStatus;
    indicatorStatus = ClassificationStatus;

}
